import React, { useState } from "react";
import { Button, Message, TextArea, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";

const NoteSettings = ({ value }) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      ...value
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label key="title" className="widget-settings__inner__label">
                     <IntlMessages id="settings.noteTitle" />:
                     <Input
                        type="noteTitle"
                        name="noteTitle"
                        style={{ width: "410px" }}
                        defaultValue={value.noteTitle}
                        onChange={handleChange}
                     />
                  </label>
                  <label key="content" className="widget-settings__inner__label">
                     <IntlMessages id="settings.noteContent" />:
                     <TextArea
                        type="content"
                        name="content"
                        style={{ width: "480px" }}
                        autoSize={{ minRows: 3, maxRows: 15 }}
                        onChange={handleChange}
                        defaultValue={value.content}
                     />
                  </label>
               </div>
               <Button className="gx-ml-4" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default NoteSettings;
